import { render, staticRenderFns } from "./InformationMessage.vue?vue&type=template&id=d8d6992c"
import script from "./InformationMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports